import { render, staticRenderFns } from "./CancelProfilePage.vue?vue&type=template&id=3a8e018b&scoped=true&"
import script from "./CancelProfilePage.vue?vue&type=script&lang=js&"
export * from "./CancelProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./CancelProfilePage.vue?vue&type=style&index=0&id=3a8e018b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e018b",
  null
  
)

export default component.exports